xplenty.filter('index', function () {
  return function ($index) {
    let index = `${$index + 1}`;
    if (index.length === 1) index = `0${index}`;
    return index;
  };
});
